import {bigDataHttp,sfHttp,otmsHttp, moonbox} from '@/utils/http/index.js'




// 调用算法的接口规划站点顺序
export function shipAddressSequence(data) {
  return sfHttp.post({ url: '/shipAddressSequence', method: 'post', data });
}


/**
 * bi 查询app定位
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/8320
 */
export function truckGeoRawDataList(data) {
  return bigDataHttp.post({ url: '/api/web/BI/pub_loc_app', method: 'post', data });
}

/**
 * 根据策略查询车辆定位信息(设备/APP)
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/18973
 */
 export function pubLocGps(data) {
  return bigDataHttp.post({ url: `/geo/web/anser/pub_loc_v2`, method: 'post', data });
}


/**
 * 获取预计送达时间
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/31699
 */
export function getEstimatedDeliveryTime(data) {
  return otmsHttp.post({ url: '/unify/order/v2/getEstimatedDeliveryTime', method: 'post', data });
}

export function getPoi(params) {
  return moonbox.get({
    url: '/v2/api/poi/search',
    params: {
      ...params,
      appId: 'customer',
      appSecret:'UWkozvZAdGDfZGnR7ucHzj60OYBXIYhF',
      size: 20
    }
  })
}